module.exports = __webpack_public_path__ + "img/202510_06.e9b0ef59.png";